import { AxiosError } from "axios"
interface ErrorMessage {
  error: string,
  status: string
}
export function catchError(error: unknown) {
  const err = error as AxiosError<ErrorMessage>
  
  return err.response?.data.error
}